/**
 * Neon color palette - Tron 1983 aesthetic
 */
// Player ship colors (8 distinct neon colors)
// First 4 are high-contrast colors for better visibility
export const PLAYER_COLORS = [
    '#ff3333', // Red
    '#3399ff', // Blue
    '#aa00ff', // Purple
    '#ffff00', // Yellow
    '#00ffff', // Cyan
    '#ff00ff', // Magenta
    '#00ff88', // Green
    '#ff6600', // Orange
];
// Entity colors
export const SHIP_OUTLINE_COLOR = '#ffffff';
export const PROJECTILE_COLOR = '#ffffff';
export const ASTEROID_COLOR = '#4488aa';
export const ASTEROID_OUTLINE_COLOR = '#66aacc';
export const CRATE_COLOR = '#ffcc00';
export const CRATE_OUTLINE_COLOR = '#ffee66';
export const STATION_COLOR = '#00ff88';
export const STATION_OUTLINE_COLOR = '#66ffbb';
// Effect colors
export const EXPLOSION_COLOR = '#ff8800';
export const TRAIL_COLOR = '#0088ff';
export const GLOW_COLOR = '#ffffff';
// UI colors
export const UI_TEXT_COLOR = '#ffffff';
export const UI_ACCENT_COLOR = '#00ffff';
export const UI_WARNING_COLOR = '#ff6600';
export const UI_DANGER_COLOR = '#ff0044';
export const LEADERBOARD_BG_COLOR = 'rgba(0, 20, 40, 0.8)';
//# sourceMappingURL=colors.js.map